import { isMac } from "./platform.ts";

/**
 * Chords the browser or the OS acts on before a page can see them, so binding
 * one records fine and then never fires. The editor warns rather than refuses:
 * the lists are the common cases, not a guarantee either way, and a user on an
 * unusual browser may know better.
 */

const SHARED = [
  "mod+t",
  "mod+n",
  "mod+w",
  "mod+shift+t",
  "mod+shift+n",
  "mod+shift+w",
  "mod+tab",
  "mod+shift+tab",
  ...Array.from({ length: 9 }, (_, i) => `mod+${i + 1}`),
];

const MAC_ONLY = ["mod+q", "mod+h", "mod+m", "mod+comma", "ctrl+tab", "ctrl+shift+tab"];

const OTHER_ONLY = ["alt+tab", "alt+f4", "alt+shift+tab"];

const RESERVED_MAC = new Set([...SHARED, ...MAC_ONLY]);
const RESERVED_OTHER = new Set([...SHARED, ...OTHER_ONLY]);

/** True when the browser or OS usually claims this combo before the page. */
export const isReservedCombo = (combo: string, mac: boolean = isMac()): boolean =>
  (mac ? RESERVED_MAC : RESERVED_OTHER).has(combo.toLowerCase());
